import { getSession, lock, onLocked, onUnlocked } from '@/core/session';
import { getPref } from '@/core/settings';

// Locks the app after a stretch without use (Settings → Account → Auto-lock). Timers sleep in
// background tabs and on a phone with the screen off, so coming back also checks how long
// the app was away.

let started = false;
let timer: ReturnType<typeof setTimeout> | null = null;
let lastActivity = Date.now();
let hiddenAt: number | null = null;

const minutes = () => getPref<number>('autoLockMin', 0);

function arm() {
  if (timer) clearTimeout(timer);
  timer = null;
  const m = minutes();
  if (!m || getSession().phase !== 'ready') return;
  timer = setTimeout(() => void lock(), m * 60_000);
}

/** Safe to call more than once. */
export function startAutoLock() {
  if (started) return;
  started = true;
  const onActivity = () => {
    // Re-arming on every event is wasteful; once a few seconds is plenty.
    const now = Date.now();
    if (now - lastActivity < 5000) return;
    lastActivity = now;
    arm();
  };
  for (const ev of ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const) {
    window.addEventListener(ev, onActivity, { passive: true });
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now();
      return;
    }
    const m = minutes();
    if (hiddenAt && m && Date.now() - hiddenAt >= m * 60_000 && getSession().phase === 'ready') {
      void lock();
    }
    hiddenAt = null;
    arm();
  });
  onUnlocked(() => {
    lastActivity = Date.now();
    arm();
  });
  onLocked(() => {
    if (timer) clearTimeout(timer);
    timer = null;
  });
  arm();
}

/** Call after the setting changes so the new delay applies right away. */
export function rearmAutoLock() {
  lastActivity = Date.now();
  arm();
}
